import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';
export const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
export const fields = [
    {
        name: 'id',
        type: 'text'
    },
    {
        name: 'status',
        placeholder: 'activationSection.statusPlaceholder',
        label: 'status',
        rules: 'required|string|in:export_active_automatic,export_active_manual',
        type: 'text',
        value: 'export_active_manual'
    },
    {
        name: 'customerId',
        placeholder: 'activationSection.customerIdPlaceholder',
        label: 'customerId',
        rules: 'required|integer',
        type: 'text'
    },
    {
        name: 'username',
        placeholder: 'activationSection.usernamePlaceholder',
        label: 'username',
        rules: 'required|string',
        type: 'text'
    },
    {
        name: 'password',
        placeholder: 'activationSection.passwordPlaceholder',
        label: 'password',
        rules: 'required|string',
        type: 'password'
    }
];
